import Vue from 'vue'
import filterRemovedClicked from '@/utils/tracking/filter-clicked'

const trackRemovedFilter = () => {
  const removedFilterName = 'amenities'
  const isFromFiltersApplied = true
  const event = filterRemovedClicked(removedFilterName, removedFilterName, isFromFiltersApplied)

  Vue.$clickstream.trackEvent(event)
}

export default {
  trackRemovedFilter,
}
